import { render, staticRenderFns } from "./liveLIst.vue?vue&type=template&id=160730c0&scoped=true&"
import script from "./liveLIst.vue?vue&type=script&lang=js&"
export * from "./liveLIst.vue?vue&type=script&lang=js&"
import style0 from "./liveLIst.vue?vue&type=style&index=0&id=160730c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160730c0",
  null
  
)

component.options.__file = "liveLIst.vue"
export default component.exports